"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RetailerSelector = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _styles = require("./styles");

var _Avatar = require("../../atoms/Avatar");

var _react = require("react");

var _AsignationOption = require("../../atoms/AsignationOption");

var _DropDownButton = require("../../atoms/DropDownButton");

var _jsxRuntime = require("react/jsx-runtime");

var RetailerSelector = function RetailerSelector(_ref) {
  var retailers = _ref.retailers,
      activeRetailer = _ref.activeRetailer,
      setActiveRetailer = _ref.setActiveRetailer,
      showStatus = _ref.showStatus;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      retailersPanel = _useState2[0],
      setRetailersPanel = _useState2[1];

  var closeRetailersPanel = function closeRetailersPanel(e) {
    if (!e.target.closest("#retailers-assignation") && retailersPanel) {
      document.removeEventListener("click", closeRetailersPanel, false);
      setRetailersPanel(false);
    }
  };

  var getRetailerImage = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              activeRetailer.image = "https://content-management-images.s3.amazonaws.com/retailers/".concat(activeRetailer.id, ".png");
              retailers.forEach(function (retailer) {
                return retailer.image = "https://content-management-images.s3.amazonaws.com/retailers/".concat(retailer.id, ".png");
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getRetailerImage() {
      return _ref2.apply(this, arguments);
    };
  }();

  (0, _react.useEffect)(function () {
    if (retailersPanel) {
      document.addEventListener("click", closeRetailersPanel, false);
    }
  }, [retailersPanel]);
  (0, _react.useEffect)(function () {
    getRetailerImage();
  }, [activeRetailer]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    id: "retailers-assignation",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Avatar.Avatar, {
      image: activeRetailer === null || activeRetailer === void 0 ? void 0 : activeRetailer.image,
      altText: activeRetailer === null || activeRetailer === void 0 ? void 0 : activeRetailer.name,
      imageType: "medium-image",
      onClick: function onClick() {
        (retailers === null || retailers === void 0 ? void 0 : retailers.length) > 0 && setRetailersPanel(!retailersPanel);
        if (retailersPanel) document.removeEventListener("click", closeRetailersPanel, false);
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DropDownButton.DropDownButton, {
      active: retailersPanel
    }), retailersPanel && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "retailers-panel",
      children: retailers.map(function (retailer, index) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_AsignationOption.AsignationOption, {
          profileImage: retailer === null || retailer === void 0 ? void 0 : retailer.image,
          imageType: "medium-image",
          asignationType: null,
          name: retailer === null || retailer === void 0 ? void 0 : retailer.name,
          team: retailer === null || retailer === void 0 ? void 0 : retailer.team,
          services: retailer === null || retailer === void 0 ? void 0 : retailer.services,
          onClick: function onClick() {
            setActiveRetailer(retailer);
            document.removeEventListener("click", closeRetailersPanel, false);
            setRetailersPanel(false);
          },
          active: retailer.id === activeRetailer.id,
          showStatus: showStatus
        }, "".concat(index, "-").concat(retailer === null || retailer === void 0 ? void 0 : retailer.name));
      })
    })]
  });
};

exports.RetailerSelector = RetailerSelector;